import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { firstValueFrom } from "rxjs";

import { IAppConfig } from "@models/app-config.model";

@Injectable()
export class AppConfig {
  static settings: IAppConfig;

  static environmentName: string;
  public featureFlags: Record<string, boolean>;

  constructor(private http: HttpClient) {}

  async load() {
    await this.loadConfig();
    await this.loadFeatureFlags();
  }

  getHealthCheckUrl(): string {
    return AppConfig.settings.serviceUrls.healthCheckUrl;
  }

  getPlantsAPIUrl(): string {
    return AppConfig.settings.serviceUrls.plantsServicesUrl;
  }

  getAppServiceUrl(service: string): string {
    return AppConfig.settings.serviceUrls[service];
  }

  getPlantGuideUrl(): string {
    return AppConfig.settings.serviceUrls.plantGuideUrl;
  }

  getPlantsUrl(): string {
    return AppConfig.settings.serviceUrls.plantsUrl;
  }

  getFeatureFlags(): { [key: string]: boolean } {
    return this.featureFlags;
  }

  getGoogleTagManagerId(): string {
    return AppConfig.settings.gtmId;
  }

  async loadConfig() {
    // there is a transformation that goes on in the CI process that will take the correct
    // config.**.json and make it into the config.json file. This means that this should not
    // be changed to something like config.dev.dev.json. The CI will take care of this.
    const jsonFile = `../assets/config.json`;
    try {
      const response: IAppConfig = await firstValueFrom(this.http.get<IAppConfig>(jsonFile));
      AppConfig.settings = response;
    } catch (error) {
      throw new Error(`Could not load file '${jsonFile}': ${JSON.stringify(error)}`);
    }
  }

  async loadFeatureFlags() {
    this.featureFlags = AppConfig.settings.featureFlags;
    AppConfig.environmentName = AppConfig.settings.env.name;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async healthCheck(): Promise<any> {
    const url = this.getHealthCheckUrl();
    try {
      return await firstValueFrom(this.http.get(url, { responseType: "text" }));
    } catch (error) {
      console.error("Health check failed", error);
      throw error;
    }
  }
}
